import { parseTranslationStrings } from '@lib/shopify'

/**
 * Retrieves an element's parent section.
 *
 * @param {HTMLElement} element - The HTML element.
 * @returns {HTMLElement} - The parent section.
 *
 * @example
 * const element = document.querySelector('.octopus');
 * const section = getSection(element);
 * console.log(section); // Output: <section class="shopify-section" id="shopify-section-sections--22653904421137__ocean">...</section>
 */
export const getSection = element => element.closest('.shopify-section')

/**
 * Retrieves the ID of an element's parent section.
 *
 * @param {HTMLElement} element - The HTML element.
 * @returns {string} - The unique identifier of the Shopify section.
 *
 * @example
 * const element = document.querySelector('.octopus');
 * const sectionId = getSectionId(element);
 * console.log(sectionId); // Output: 'sections--22653904421137__ocean'
 */
export const getSectionId = element => getSection(element)?.id.replace('shopify-section-', '')

/**
 * Retrieves and formats a translation string from the global translation strings object.
 * Supports nested paths using dot notation and replacement of placeholders.
 *
 * @param {string} path - Dot-notation path to the translation string (e.g. 'common.buttons.submit')
 * @param {Object} [replacements={}] - Object containing key-value pairs for placeholder replacements
 * @returns {string} The formatted translation string with replacements applied
 * @example
 * // With nested path and replacements
 * t('common.buttons.submit', { count: 5 }) // Returns "Submit 5 items"
 */
export const t = (path, replacements = {}) => {
  window.translationStrings ??= parseTranslationStrings()

  const getString = (...keys) => {
    let value = window.translationStrings
    for (const key of keys) {
      value = value[key]
    }
    return value
  }

  let stringValue = getString(...path.split('.'))

  for (const [key, value] of Object.entries(replacements)) {
    stringValue = stringValue.replace(`[${key}]`, value)
  }

  return stringValue
}

export const parseGID = gid => {
  if (typeof gid === 'number') return gid

  return Number.parseInt(gid.split('/').pop().trim(), 10)
}

export const pauseAllMedia = () => {
  for (const video of document.querySelectorAll('.js-youtube')) {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
  }
  for (const video of document.querySelectorAll('.js-vimeo')) {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  }
  for (const video of document.querySelectorAll('video')) {
    video.pause()
  }
  for (const model of document.querySelectorAll('product-model')) {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  }
}
